import TeamDetailMember from '@/screens/TeamDetailMember';

export default function PrivateTabsOrganizationTeamTeamIdIndexRoute() {
  return (
    <TeamDetailMember memberPathname="/organization/team/member/[personId]" />
  );
}
